import { Box } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import VehicleCarSharingSearch from "../component/vehicle-carsharing/VehicleCarSharingSearch";

const VehicleCarSharingPage = (props: any) => {
  return (
    <Box>
      <Routes>
        <Route path="/" element={<VehicleCarSharingSearch />} />
      </Routes>
    </Box>
  );
};

export default VehicleCarSharingPage;
